<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.id" placeholder="请输入商户ID">
						</el-input>
					</el-form-item>
					<el-form-item label="商户名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入商户名">
						</el-input>
					</el-form-item>
					
					<!-- <el-form-item label="收款类型" class='tiny '>
						<el-select v-model="searchInfo.cardType" placeholder="请选择" clear>
							<el-option key="1" label="公司账户" :value="1">公司账户</el-option>
							<el-option key="2" label="支付宝" :value="2">支付宝</el-option>
							<el-option key="3" label="微信" :value="3">微信</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="状态" class='tiny '>
						<el-select v-model="searchInfo.status" placeholder="请选择" clear>
							<el-option key="0" label="待审核" value="0">待审核</el-option>
							<el-option key="1" label="已完成" value="1">已完成</el-option>
							<el-option key="2" label="已驳回" value="2">已驳回</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="充值时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile">
								导出
								<a href=""></a>
							</el-button> -->
							<el-button type="primary" @click="recharge">充值</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<div style="margin-left: 20px;margin-bottom: 20px;">
			<span>充值总余额：{{amountSum}}元</span>
		</div>
		<el-table :data="payList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="id" label="商户ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="storeName" label="商户名" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="amount" label="充值总金额(￥)" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="审核状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 0">待审核</div>
					<div  v-if="scope.row.status == 1">充值成功</div>
					<div v-if="scope.row.status == 2">已驳回</div>
				</template>
			</el-table-column>
			<el-table-column prop="cardType" label="充值类型" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.cardType == 1">公司账户</div>
					<div v-if="scope.row.cardType == 2">支付宝</div>
					<div v-if="scope.row.cardType == 3">微信</div>
				</template>
			</el-table-column>
			<el-table-column label="查看凭证" align="center" prop="certificateImg" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showContent(scope.row.certificateImg)">查 看
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="createTime" label="充值时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="checkDatetime" label="审核时间" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.updateTime">{{scope.row.updateTime}}</div>
					<div v-else>未审核</div>
				</template>
			</el-table-column>
			<el-table-column prop="username" label="审核人" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
				<div v-if="scope.row.checkBy">{{scope.row.checkBy}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="reasonsforrefusal" label="驳回原因" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.reasonsforrefusal">{{scope.row.reasonsforrefusal}}</div>
					<div v-else>无</div>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<el-table-column label="操作" align="center" width="140">
				<template slot-scope="scope">
				
					<el-button v-if="scope.row.status == 0" size="small" type="text"
						@click="open(scope.row.id,scope.row.storeId)">审 核</el-button>
						
					<el-button v-if="scope.row.status == 0" size="small" type="text"
						@click="queryIntegralWithdrawal(scope.row.id,4,'驳 回')">驳 回</el-button>
					<div v-if="scope.row.status == 2">不可操作</div>
					<div v-if="scope.row.status == 1">已完成</div>
				
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="payList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper"
			:total="payList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="打款凭证" :visible.sync="showContentDialog" width="85%" :close-on-click-modal="false">
			<!-- <span v-html="contentValue"></span> -->
			<img v-if="contentValue" :src="contentValue" mode='scaleToFill' style="width: 100%;" />
			<!-- <span v-else>请上传图片</span> -->
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">关 闭</el-button>
			</span>
		</el-dialog>

		<!-- 查看收款信息 -->
		<el-dialog style="float:rigin" :title="title" :visible.sync="queryDialogVisible" width="50%"
			:close-on-click-modal="false">

			<div class="app-container" style="text-align: center;">
				<el-form size="medium">

					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="充值类别:" class="redItem">
							<div v-if="integralWithdrawal.cardType == 1">银行卡</div>
							<div v-if="integralWithdrawal.cardType == 2">支付宝</div>
							<div v-if="integralWithdrawal.cardType == 3">微信</div>
						</el-form-item>

						<el-form-item v-if="integralWithdrawal.cardUserName" label="姓名:" class="redItem">
							{{integralWithdrawal.cardUserName}}
						</el-form-item>

					</div> -->

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item v-if="integralWithdrawal.cardBank" label="充值金额:" class="redItem">
							{{integralWithdrawal.cardBank}}
						</el-form-item>	
						<!-- <el-form-item v-if="integralWithdrawal.cardBank" label="开户银行:" class="redItem">
							{{integralWithdrawal.cardBank}}
						</el-form-item>
							<!- -->
						<el-form-item v-if="integralWithdrawal.cardSubbranch" label="开户支行:" class="redItem">
							{{integralWithdrawal.cardSubbranch}}
						</el-form-item> 
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardNo" label="账号:" class="redItem">
							{{integralWithdrawal.cardNo}}
						</el-form-item>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item v-if="integralWithdrawal.cardImg" label="收款二维码图片:" class="redItem">
							<img :src="integralWithdrawal.cardImg" width="60%" />
						</el-form-item>
					</div>

					<div v-if="type == 2 || type == 3" style="display: flex;align-items: center;justify-content: space-between;">

						<el-form-item :label-width="formLabelWidth" label="充值金额:">
							<el-input type="number"  />
						</el-form-item>

						<el-form-item :label-width="formLabelWidth" label="打款凭证:">
							<template slot-scope="scope">
								<img v-if="integralWithdrawal.systemDocuments" :src="integralWithdrawal.systemDocuments" width="40%" />
								<div v-else>请上传图片</div>
							</template>
						</el-form-item>
					</div>

					<div v-if="type == 4" style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="驳回原因:" class="redItem" style="width: 100%;">
							<el-input style="width: 100%;" v-model="integralWithdrawal.reason" placeholder="请输入驳回原因">
							</el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button v-if="type == 2 || type == 3" type="primary" @click="remit">转 帐 完 成</el-button>
				<el-button v-if="type == 1" type="primary" @click="queryDialogVisible = false">关 闭</el-button>
				<el-button v-if="type == 4" type="primary" @click="reject">驳 回</el-button>
				<el-button v-if="type == 2 || type == 3 || type == 4" @click="queryDialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>
		<!-- 充值 -->
		<el-dialog style="float:rigin" title="充值" :visible.sync="dialogVisiblerecharge" width="50%"
		:close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="充值方式:">
						<el-col :span="8">
							<el-select v-model="rechargeform.cardType" class="big" placeholder="请选择" clear @change="paytype">
								<el-option v-for="(item,index) in pay" :value="item.type" :label="item.name">
								
								</el-option>
								
							</el-select>
						</el-col>
					</el-form-item>
					<div style="border: 2px solid #7f7f7f;padding: 5px;border-radius: 5px;width: 400px;" v-if="paylist.cardType">
						<el-form-item label="收款方:" v-if="paylist.cardUserName&&paylist.cardType==1">
						<span>{{paylist.cardUserName}}</span>
						</el-form-item>
						<el-form-item label="收款银行:" v-if="paylist.cardBank">
						<span>{{paylist.cardBank}}</span>
						</el-form-item>
						<el-form-item label="银行支行:" v-if="paylist.cardSubbranch">
						<span>{{paylist.cardSubbranch}}</span>
						</el-form-item>
						<el-form-item label="银行卡号:" v-if="paylist.cardBankNo">
						<span>{{paylist.cardBankNo}}</span>
						</el-form-item>
						<el-form-item label="收款图片" v-if="paylist.cardImg">
							<img :src="paylist.cardImg" alt="" style="width: 200px;">
						</el-form-item>
					</div>
					<el-form-item label="充值金额:">
						<el-col :span="10">
							<el-input type="number" v-model="rechargeform.amount" placeholder="请输入充值金额" />
						</el-col>
					</el-form-item>
					<el-form-item label="上传凭证:">
						
						<el-upload :action="httpUrl" list-type="picture-card"
							:on-preview="reghandlePictureCardPreview" :on-remove="reghandleRemove"
							:file-list="regfileList" :show-file-list="true" :on-success="regonSuccess">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
					
					<el-form-item label="备注:">
						<el-col :span="10">
							<el-input type="text" v-model="rechargeform.remark" placeholder="请输入备注" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisiblerecharge = false">取 消</el-button>
				<el-button type="primary" @click="surereg()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFile
	} from "@/api/axios.js";
	var urls = uploadFile('integralWithdrawal');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				title: '',
				imgUrl: urls,
				regfileList: [],
				httpUrl: urls,
				fileList: [],
				username:'',
				type: 0,
				amountSum:'',
				user:'',
				pay:"",
				dialogVisiblerecharge:false,
				loading: false,
				payList: [], //档位列表
				integralWithdrawal: {},
				rejectDialogVisible: false,
				queryDialogVisible: false,
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				ids: '', //id
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false,
				rechargeform:{},
				paylist:{},
				regimg:[]
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			regonSuccess(response, file, fileList) {
				// console.log(res)
				this.regimg.push(response.message);
				// console.log("asda",response,this.goodsImages)
			},
			reghandleRemove(file, fileList) {
				if (file.response) {
					this.regimg.remove(file.response.message);
				}
				this.regimg.remove(file.url);
			},
			reghandlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisiblerecharge = true;
			},
			paytype(e){
				// console.log(e);
			
				this.$api.findListById(0).then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					this.paylist=res.data.find(item=>item.cardType==e)
					// console.log(this.paylist);
				})
				
			},
			recharge(){
				this.dialogVisiblerecharge=true
				this.paylist={}
				this.rechargeform.cardType=''
		
			},
			surereg(){
					
				
				this.$api.addRecharge(this.$encrypt({
					certificateImg:this.regimg.join(','),
				
					...this.rechargeform
					})).then(res=>{
					if(res.state=='success'){
						
					
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.dialogVisiblerecharge=false
					}else{
						this.$message.error(res.message
						)	
					}
			
				})
			},
			getAmount(){
				let data={
						phone: this.searchInfo.phone,
						cardType: this.searchInfo.cardType,
						status: this.searchInfo.status,
						username:this.searchInfo.username,
						userId: this.searchInfo.userId,
						orderType: this.searchInfo.orderType,
						storeName:this.searchInfo.storeName,
						startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
						cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.AmountSum(this.$encrypt(data)).then(res=>{
					// console.log(res);
					res.data=JSON.parse(this.$decrypt(res.data)).data
					this.amountSum=res.data.data
				})
			},
			showloadFile(res) {
				if (!res) {
					return
				}
				const link = document.createElement('a');
				let blob = new Blob([res], {
					type: 'application/vnd.ms-excel'
				});
				link.style.display = 'none';
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', '充值记录' + '.xls');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			},
			downloadFile() { //导出
				let data = {
					phone: this.searchInfo.phone,
					cardType: this.searchInfo.cardType,
					status: this.searchInfo.status,
					username:this.searchInfo.username,
					orderType: this.searchInfo.orderType,
					userId: this.searchInfo.userId,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.rechargeExcel(data).then((res) => {
					// console.log(res.data)
					this.showloadFile(res.data)
				})
			},
			reject() {
				// console.log(scope.row.id);
				let data=this.username+'~'+this.ids
				this.$api.rechargeRejected(this.$encrypt({
					reasonsforrefusal:this.integralWithdrawal.reason,
					id:this.integralWithdrawal.id,
					checkBy:data
				})).then((res) => {
				// 	console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.integralWithdrawal.reason = ''
					this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
				})
				// this.$api.integralWithdrawalReject(this.integralWithdrawal).then((res) => {
				// 	console.log('res', res)
				// 	if (res.state == 'success') {
				// 		this.$message({
				// 			message: res.message,
				// 			type: 'success'
				// 		});
				// 		this.queryDialogVisible = false;
				// 		this.findpayList();
				// 	} else {
				// 		this.$message.error(res.message);
				// 	}
				// })
			},
			remit() {
				this.$api.haveMoney(this.integralWithdrawal).then((res) => {
					// console.log('res', res)
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.queryDialogVisible = false;
						this.findBypayList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			queryIntegralWithdrawal(e, type, title) {
				// console.log(e,type, '123',this.integralWithdrawal);
				this.fileList = [];
				this.title = title;
				this.queryDialogVisible = true;
				this.type = type;
				this.integralWithdrawal.id=e
				
				
			},
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				var integralWithdrawal = {
					id: this.integralWithdrawal.id,
					cardType: this.integralWithdrawal.cardType,
					cardUserName: this.integralWithdrawal.cardUserName,
					cardBank: this.integralWithdrawal.cardBank,
					cardSubbranch: this.integralWithdrawal.cardSubbranch,
					cardNo: this.integralWithdrawal.cardNo,
					cardImg: this.integralWithdrawal.cardImg,
					systemDocuments: response.data
				}
				this.integralWithdrawal = integralWithdrawal;
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				let webData = {
					pageNum: 1,
					pageSize: this.page.pageSize,
					phone: this.searchInfo.phone,
					cardType: this.searchInfo.cardType,
					status: this.searchInfo.status,
					
					orderType: this.searchInfo.orderType,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.getAmount()
				// console.log(webData)
				this.$api.findByRechargeRecord(this.$encrypt({
					pageNum: 1,
					pageSize: this.page.pageSize,
					cardType:this.searchInfo.cardType,
					phone:this.searchInfo.phone,
					username:this.searchInfo.username,
					userId:this.searchInfo.userId,
					status:this.searchInfo.status,
					storeName:this.searchInfo.storeName,
					startTime:this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				})).then((res) => {//提现申请列表
				// console.log(res);
				res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.payList = res.data
					}
					this.loading = false
				})
			},
			showContent(content) {
				this.contentValue = content
				// console.log(content)
				this.showContentDialog = true
			},
			
			open(id,storeId){
				  this.$confirm('确认充值金额与凭证相符吗?', '充值', {
				          confirmButtonText: '确定',
				          cancelButtonText: '取消',
				          type: 'warning'
				        }).then(() => {
							
							let data=this.username+'~'+this.ids
							// console.log(data)
							this.$api.rechargeBalance(this.$encrypt({checkBy:data,storeId:storeId,id:id})).then(res=>{
								if(res.state=='success'){
									this.$message({
									  type: 'success',
									  message: res.message
									});
									 this.findBypayList();
								}
							})
				      
						 
				        }).catch(() => {
				          this.$message({
				            type: 'info',
				            message: '已取消充值'
				          });          
				        });
			},
			//编辑弹框
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.findBypayList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.findBypayList()
			},
			findBypayList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					cardType:this.searchInfo.cardType,
					phone:this.searchInfo.phone,
					username:this.searchInfo.username,
					userId:this.searchInfo.userId,
					status:this.searchInfo.status,
					startTime:this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				}
				this.$api.findByRechargeRecord(this.$encrypt(data)).then((res) => { //提现申请列表
						res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.payList = res.data
						this.loading = false
						this.$api.getUserInfo().then(res=>{
						res.data=JSON.parse(this.$decrypt(res.data)).data.user
				
							this.username=res.data.username
							this.ids=res.data.id
						
						})
					}
				})
			
				
			}
		},
		created() {
			
			this.getAmount()
		
			this.findBypayList();	
				// console.log(this.ids,this.username);
				this.$api.findSettingValueByKey('is_bank').then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
				this.pay=JSON.parse(res.data.settingValue).filter(item=>item.status==1)
				
				})
		},
		mounted: function () { 
		
		},
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>